// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"438bd1c9","833":"a56424c5"}[chunkId] + ".chunk.js";
};